import { juniorSeriesObjs, leatherIntegratedIndexObjs, seriesObjs } from 'src/features/yellStory/constants/bases'
import { State, StateObj } from 'src/types'

const leatherIntegrateOptionMsg = 'オプション料金(税込3,300円)がかかります。※2箇所目以降は税込1,650円'

export const baseCautionGenerator = (condition: boolean, partsKey: string): string => {
  if (condition) {
    switch (partsKey) {
      case 'size':
        return 'オプション料金(税込3,300円)がかかります。'
      case 'leatherIntegratedIndex':
      case 'leatherIntegratedMiddle':
      case 'leatherIntegratedRing':
        return leatherIntegrateOptionMsg
    }
  }
}

export const baseDescriptionGenerator = (condition: boolean, partsKey: string): string => {
  if (condition) {
    switch (partsKey) {
      case 'fingerGuardType':
        return '革一体形状(人差指)と指当てを同時に指定することはできません。'
      case 'leatherIntegratedIndex':
        return '指あて設定をご指定後、選択いただけます。'
      case 'series':
        return 'シリーズを変更したい場合、画面一番下の【リセット】ボタンをしてください。'
    }
  }
}

export const indexFingerObjectsSwitcher = (condition: boolean): StateObj[] => {
  const objects = condition
    ? [{ label: '無し', value: 'none', imageUrl: '/yellstory/baseSettings/leatherIntegrated/index/none.jpg' }]
    : leatherIntegratedIndexObjs
  return objects
}

const leatherIntegratedChecker = (object: StateObj): boolean => {
  const bool = object.value !== 'none' && object.value !== 'unselected'
  return bool
}

export const ysrFlagGenerator = (state: State) => {
  const { size, fingerGuardType, leatherIntegratedIndex, leatherIntegratedMiddle, leatherIntegratedRing, embroideries } = state
  const isDefaultSize = size.value === 'default'
  const isSelectedFingerGuard = fingerGuardType.value !== 'unselected'
  const isIndexOption = leatherIntegratedChecker(leatherIntegratedIndex)
  const isMiddleOption = leatherIntegratedChecker(leatherIntegratedMiddle)
  const isRingOption = leatherIntegratedChecker(leatherIntegratedRing)
  const isSelectedMiddleFingerEmbroidery = embroideries.some((e) => e.position.value === 'middleFinger')
  const isSelectedRingFingerEmbroidery = embroideries.some((e) => e.position.value === 'ringFinger')
  const isIndexFingerGuard = fingerGuardType.value !== 'none'
  const isJuniorLine = ['SS016JI', '2B041JI'].includes(state?.baseModel.productNumber)
  const isSelectedSeries = state.series?.value !== 'unselected'
  return {
    isDefaultSize,
    isSelectedFingerGuard,
    isIndexOption,
    isMiddleOption,
    isRingOption,
    isSelectedMiddleFingerEmbroidery,
    isSelectedRingFingerEmbroidery,
    isIndexFingerGuard,
    isJuniorLine,
    isSelectedSeries
  }
}

export const seriesObjectsGenerator = (isJuniorLine: boolean): StateObj[] => (isJuniorLine ? juniorSeriesObjs : seriesObjs)
